import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import LensIcon from '@material-ui/icons/Lens';
import PauseIcon from '@material-ui/icons/Pause';
import PlayIcon from '@material-ui/icons/PlayArrow';
import { styles } from '../../styles/slideshow-styles';

function AutoplayControl(props) {
    if(props.autoplay) {
      return (
        <IconButton onClick={props.handlePauseSlideshow}>
          <PauseIcon color="secondary" fontSize="small" />
        </IconButton>
      )
    } else {
      return (
        <IconButton onClick={props.handlePlaySlideshow}>
          <PlayIcon color="secondary" fontSize="small" />
        </IconButton>
      )
    }
  }



AutoplayControl.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AutoplayControl);



// WEBPACK FOOTER //
// ./src/components/slideshow/AutoplayControl.js